<template>
  <div style="background-color:#eee;">
    <div class="banner">
      <img src="https://firebasestorage.googleapis.com/v0/b/foxfox-honda.appspot.com/o/LOGO_VGxLIA-01.png?alt=media&token=ad128f7b-1718-4830-8534-c06999f9e338" style="height:90px !important;">
    </div>
    <section class="section" v-if="!userListReady">
      <br>
      <b>รอสักครู่ กำลังดึงประวัติการเข้าใช้บริการ</b>
      <br><br>
    </section>
    <div v-if="userList.length > 0">
      <br>
      <b>รายชื่อลูกค้าที่เคยเข้าใช้บริการ</b>
      <table class="table is-striped is-fullwidth">
        <tr v-for="(user) in userList" v-bind:key="user.userId">
          <td><img :src="user.user.pictureUrl" width="70"></td>
          <td>{{user.customerName}}<br>({{user.user.displayName}})</td>
          <td><input type="button" :value="btn_select_action" v-on:click="selectSubmit(user.userId, user.customerName)"></td>
        </tr>
      </table>
    </div>
    <section class="section">
      <div class="card">
        <div class="card-image"><br>
          <figure class="image">
            <qrcode-vue :value="urlconfirm" :size="size" level="H"></qrcode-vue>
          </figure>
        </div>
        <div class="card-content">
          <div class="content">
            ทะเบียน {{ carInfo.licenseNo }}<br>
            เลขที่ตัวถัง {{ carInfo.frameNo }}<br>
          </div>
        </div>
      </div>
      <span class="error" v-show="alreadyConfirm">ลูกค้าเคยลงทะเบียนแล้ว</span>
    </section>
    <div>
      <img src="https://firebasestorage.googleapis.com/v0/b/foxfox-honda.appspot.com/o/intro_progress.jpg?alt=media&token=e1116019-6498-479e-8c28-ec2ac8078171" style="height:300px !important;">
    </div>

    <div style="text-align:right;padding-right:20px;">
      <button  class="button is-light" v-on:click="manualSubmit" >{{btn_action}}</button>
    </div>
    <br><br>
    {{urlconfirm}}
  </div>
</template>
<style>
.error {
  color: red;
  font-size: 16px;
  font-weight: bold;
}
.banner {
  text-align: center;
  background-color: #000;
}
.section {
  padding: 1.5rem 1.5rem;
}
</style>
<script>
import QrcodeVue from 'qrcode.vue'

export default {
  name: 'QRCodeBP',
  beforeCreate () {
    this.$liff.init({ liffId: this.$liffId_Service_QRCodeBP }, function (data) {})
  },
  components: {
    QrcodeVue
  },
  data: () => ({
    alreadyConfirm: false,
    urlconfirm: `line://app/1653760842-vxdJxgNo?`,
    size: 150,
    profile: {
      userId: '',
      displayName: '',
      pictureUrl: '',
      statusMessage: ''
    },
    branch: [],
    branchSelected: '',
    branchCode: '',
    carInfo: {
      branchId: '',
      customerName: '',
      frameNo: '',
      licenseNo: ''
    },
    carId: '',
    test: '',
    btn_action: 'Manual',
    btn_select_action: 'Confirm',
    userList: [],
    userListReady: false
  }),
  async mounted () {
    let _this = this
    _this.branch = this.$branchList
    // _this.getProfile()
    _this.test = window.location
    let queryString = decodeURIComponent(decodeURIComponent(window.location.search).replace('?liff.state=', ''))
    queryString = queryString.replace('/qrcode?', '')
    _this.test = queryString
    const params = new URLSearchParams(queryString)
    _this.branchCode = params.get('branchCode')
    _this.carId = params.get('carId')
    _this.branch.map((item) => {
      _this.branchSelected = (item.id === _this.branchCode) ? item.name : _this.branchSelected
      return true
    })
    _this.urlconfirm += `branchCode=${_this.branchCode}&carId=${_this.carId}`
    await _this.getCarInfo()
    await _this.getUserFrame()
  },
  methods: {
    async getCarInfo () {
      let _this = this
      await this.$axios
        .get(`${this.$apiUrl}getBPInfo?carId=${_this.carId}`)
        .then(response => {
          _this.carInfo = response.data
          if (_this.carInfo.confirmTime) {
            _this.alreadyConfirm = true
          }
        })
    },
    async getUserFrame () {
      let _this = this
      _this.userList = []
      await this.$axios
        .get(`${this.$apiUrl}getJobFrameNo?frameNo=${_this.carInfo.frameNo}`)
        .then(async (response) => {
          const result = response.data
          let userExist = []
          await result.item.forEach((user) => {
            if (user.userId !== '-1' && user.userId !== '' && typeof user.userId !== 'undefined') {
              if (typeof userExist[user.userId] === 'undefined') {
                _this.userList.push(user)
                userExist[user.userId] = user
              }
            }
          })
        })
      _this.userListReady = true
    },
    manualSubmit () {
      if (!confirm('คุณต้องการทำรายการแบบ manual ใช่หรือไม่')) {
        return false
      }
      let _this = this
      _this.btn_action = 'กำลังดำเนินการ'
      _this.carInfo.branchId = _this.branchCode
      let params = {
        userId: -1,
        carId: _this.carId
      }
      this.$axios
        .post(`${this.$apiUrl}setCustomerConfirmBP`, params)
        .then(response => {
          _this.btn_action = 'ดำเนินการเรียบร้อยแล้ว'
        })
    },
    selectSubmit (userId, name) {
      if (!confirm(`ยืนยันเลือกลูกค้าชื่อ ${name} ใช่หรือไม่`)) {
        return false
      }
      let _this = this
      _this.btn_select_action = 'กำลังดำเนินการ'
      _this.carInfo.branchId = _this.branchCode
      let params = {
        userId: userId,
        carId: _this.carId
      }
      this.$axios
        .post(`${this.$apiUrl}setCustomerConfirmBP`, params)
        .then(response => {
          _this.btn_select_action = 'ดำเนินการเรียบร้อยแล้ว'
          _this.closeWindow()
        })
    },
    closeWindow () {
      this.$liff.closeWindow()
    },
    sendMessage () {
      let _this = this
      this.$liff.sendMessages([
        {
          type: 'text',
          text: 'You/\'ve successfully sent a message! Hooray!'
        },
        {
          type: 'sticker',
          packageId: '2',
          stickerId: '144'
        }
      ]).then(function () {
        _this.closeWindow()
        console.log('Message sent')
      }).catch(function (error) {
        console.log('Error sending message: ' + error)
      })
    },
    getProfile () {
      let _this = this
      this.$liff.getProfile().then(function (profile) {
        _this.profile = profile
      }).catch(function (error) {
        console.log('Error getting profile: ' + error)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/QRCodeBP.vue